import "./LoaderDots.css";

export const LoaderDots = () => {
  return (
    <div className="loader">
      {[...Array(5)].map((_, index) => (
        <div
          key={index}
          className="dot"
          style={{ animationDelay: `${index * 0.4}s` }} // Délai modifié pour espacer chaque animation
        ></div>
      ))}
    </div>
  );
};
